import React from "react";
import DocumentGrid from "./DocumentGrid";
import ImageGrid from "./ImageGrid";
import { AssetType } from "../../types/AssetType";
import { useSelector } from "react-redux";
import {userIsDocCollector} from "../../helpers/users";

interface AssetGridProps {
    assetSize: string;
    assetType: AssetType;
    elementId: string;
}

export default function ArtifactGrid({
    assetType,
    elementId,
    assetSize
}: AssetGridProps) {
    const activeInspection = useSelector(
        (state: any) => state.portal.activeInspection
    );

    const isDocumentCollector: boolean = useSelector((state: any) => userIsDocCollector(state));

    let grid;

    switch (assetType) {
        case AssetType.Image:
            grid = (
                <ImageGrid
                    elementId={elementId}
                    assetSize={assetSize}
                    deactivated={
                        activeInspection.SurveyorCompletionStatus.PhotosComplete
                    }
                />
            );
            break;
        case AssetType.Document:
            grid = (
                <DocumentGrid
                    elementId={elementId}
                    assetSize={assetSize}
                    deactivated={
                        activeInspection.SurveyorCompletionStatus
                            .DocumentsComplete && !isDocumentCollector
                    }
                />
            );
            break;
        case AssetType.CheckList:
            grid = <div> Checklist grid is not implemented. </div>;
            break;
    }

    return <div>{grid}</div>;
}
